import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Events } from '@/events';
import { NAVIGATION_MENUS } from '@/utils/constants';
import { appConfigService } from '@/providers/services/app/app-config';
import { sessionService } from '@/providers/services/auth/session';


@Component({ name: 'app-header-nav' })
export default class AppHeaderNav extends Vue {

  // -------------------------------------------------------------------------
  //  Properties
  @Prop()
  public disableMenu: any;

  private currentRoutePath: string = '/network';


  private submenuStyle: any = {};

  // -------------------------------------------------------------------------
  // Computed Properties

  /**
   * Navigation menu items
   * @property {Array}
   */
  get menuItems() {
    return NAVIGATION_MENUS;
  }

  @Watch('$route')
  public activeRouterCheck(value: any) {
      this.currentRoutePath = value.path;
  }

  get isTenantAdmin() {
    const report = this.$access.menus;
    return this.$access.hasMenuAccess(report.reports);
  }

  get session() {
    return sessionService.getSession();
  }

  get demoTenant() {
    return appConfigService.demoTenant();
  }

  get isShowcaseEnable() {
    const userId = this.session && this.session.user_id;
    return this.demoTenant.includes(userId) ? false : appConfigService.getShowcaseEnable();
  }

  get isImpactCaseEnable() {
    const userId = this.session && this.session.user_id;
    return this.demoTenant.includes(userId) ? true : appConfigService.getImpactcaseEnable();
  }

  get isShowImpact() {
    const impact = appConfigService.getShowImpact();
    const userId = this.session && this.session.user_id;
    return userId && impact && impact.length && impact.includes(userId) ? true : false;
  }

  // get isSuperUser(){
  //   return this.$access.hasPermission(this.$access.menus.all, this.$access.ACL.all);
  // }

  get isDemoTenant() {
    return this.$access.isGuestUser('hide-catalog', 'hide-catalog');
  }

  get hiddenMenus() {
    return appConfigService.getHiddenMenus() || [];
  }



  // -------------------------------------------------------------------------
  //  Hooks

  public mounted() {
    this.currentRoutePath = this.$router.currentRoute.path;
  }

  // -------------------------------------------------------------------------
  //  Actions

  private onChangeRoute(currentPath: string) {
    this.currentRoutePath = currentPath;
    this.$router.push(currentPath);
    this.$emit('send', currentPath);
  }

  private onloadMenuList(item: any) {
    if (this.isTenantAdmin && item.key === this.$access.menus.network) {
      return this.$access.menus.reports;
    } else if (this.isTenantAdmin && item.key === this.$access.menus['data-lake']) {
      return 'Learning Registry';
    } else {
      return item.name;
    }
  }

  // ------------------------------------------------------------------
  // Methods
  private activeRoutes(item: any) {
    return !item.subMenu ? this.currentRoutePath.includes(item.path)
      : item.subMenu.find((path: any) => this.currentRoutePath.includes(path.path));
  }

}
